import * as React from "react";

const IdentifyCard = ({ fill, size }: { fill?: string; size?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="identity-card"
    viewBox="0 0 1000 1000"
    width={size ? size : 24}
    height={size ? size : 24}
  >
    <path
      fill={fill ? fill : "#2c2c2c"}
      d="M833.08 793.54H166.92A83 83 0 0 1 84 710.62V289.38a83 83 0 0 1 82.92-82.92h666.16A83 83 0 0 1 916 289.38v421.24a83 83 0 0 1-82.92 82.92M166.92 238.46A51 51 0 0 0 116 289.38v421.24a51 51 0 0 0 50.92 50.92h666.16A51 51 0 0 0 884 710.62V289.38a51 51 0 0 0-50.92-50.92Z"
    ></path>
    <path fill={fill ? fill : "#2c2c2c"} d="M361.49 703.86H210.37a54.34 54.34 0 0 1-54.28-54.28v-48.86a110.64 110.64 0 0 1 110.52-110.51h38.65a110.63 110.63 0 0 1 110.51 110.51v48.86a54.34 54.34 0 0 1-54.28 54.28m-94.88-181.65a78.61 78.61 0 0 0-78.52 78.51v48.86a22.31 22.31 0 0 0 22.28 22.28h151.12a22.31 22.31 0 0 0 22.28-22.28v-48.86a78.6 78.6 0 0 0-78.51-78.51zm19.32-50.49a87.79 87.79 0 1 1 87.79-87.79 87.89 87.89 0 0 1-87.79 87.79m0-143.58a55.79 55.79 0 1 0 55.79 55.79 55.86 55.86 0 0 0-55.79-55.79m536.44 27.17h-341a16 16 0 0 1 0-32h341a16 16 0 0 1 0 32m0 107.13h-341a16 16 0 0 1 0-32h341a16 16 0 0 1 0 32m0 107.12h-341a16 16 0 1 1 0-32h341a16 16 0 0 1 0 32m0 107.13h-341a16 16 0 1 1 0-32h341a16 16 0 0 1 0 32"></path>
  </svg>
);

export default IdentifyCard;
